import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, FormText, Input, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup, InputGroupAddon} from 'reactstrap';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, getByAtribute, stringToArray} from "../../../utils/formatar";

@inject("store")
@observer
export class EmpregadosSubstituidosForm extends Component {

    static propTypes = {
        matriculaEmpregadosSubstituidos: PropTypes.array,
        empregadosSubstituidos: PropTypes.array,
        solicitacaoExcecao: PropTypes.bool,
        removerEmpregadoSubstituido: PropTypes.func,
        adicionarEmpregadoSubstituido: PropTypes.func,
        filtrarEmpregados: PropTypes.func,
        setMatriculaEmpregadosSubstituidos: PropTypes.func,
        empregadosSubstituidosMin: PropTypes.number,
        empregadosSubstituidosMax: PropTypes.number,
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const empregadosSubstituidosForm = [];
        const empregadosSubstituidosMin = _.get(this.props, "empregadosSubstituidosMin", 0) || 0;
        const empregadosSubstituidosMax = _.get(this.props, "empregadosSubstituidosMax", 0) || 0;
        const empregadosRecuperados = _.get(this.props.controller, "solicitacao.empregadosSubstituidos", []);

        const obterMatriculaSelecionada = (valor) => {
            if (!valor) {
                return "";
            }
            if (typeof valor === "object") {
                return valor.value ? String(valor.value) : "";
            }
            return String(valor);
        };

        const obterValorSelect = (valorAtual) => {
            if (!valorAtual || typeof valorAtual === "object") {
                return valorAtual;
            }

            const valorNormalizado = String(valorAtual);
            const empregado = this.props.controller.empregadosFiltrados.find(elem => String(elem.matricula) === valorNormalizado || String(elem.cpf) === valorNormalizado)
                || empregadosRecuperados.find(elem => String(elem.matricula) === valorNormalizado || String(elem.cpf) === valorNormalizado);

            if (!empregado) {
                return {
                    value: valorNormalizado,
                    label: valorNormalizado
                };
            }

            const cpf = !!empregado.cpf ? " (" + empregado.cpf + ")" : "";
            return {
                value: valorNormalizado,
                label: valorNormalizado + " - " + empregado.nome + cpf
            };
        };

        for(let i=0;i<_.get(this.props, "matriculaEmpregadosSubstituidos.length", 0);i++) {
            const matriculaLinhaAtual = obterMatriculaSelecionada(this.props.matriculaEmpregadosSubstituidos[i]);
            const matriculasJaSelecionadas = this.props.matriculaEmpregadosSubstituidos
                .map(obterMatriculaSelecionada)
                .filter(matricula => !!matricula && matricula !== matriculaLinhaAtual);

            empregadosSubstituidosForm.push(<Row key={i}>
                <Col xs={12} lg={8}>
                    {this.props.matriculaEmpregadosSubstituidos[i] !== null &&
                    <FormGroup>
                        <div className="multiple-selects">
                            <Select
                                className={this.props.solicitacaoExcecao ? "multiple-selects-input no-buttons" : "multiple-selects-input"}
                                searchPromptText="Informe CPF ou matrícula para pesquisar"
                                noResultsText={"Empregado não encontrado ou já associado"}
                                placeholder="Selecione..."
                                value={obterValorSelect(this.props.matriculaEmpregadosSubstituidos[i])}
                                autoload={false}
                                onChange={(value) => this.props.setMatriculaEmpregadosSubstituidos(value, i)}
                                asyncOptions={(input, callback) => {
                                    this.props.filtrarEmpregados(input, (error, result) => {
                                        const options = _.get(result, "options", []);
                                        const optionsSemDuplicados = options.filter(option => {
                                            const matriculaOption = option && option.value ? String(option.value) : "";
                                            return matriculaOption && matriculasJaSelecionadas.indexOf(matriculaOption) === -1;
                                        });

                                        callback(error, {
                                            options: optionsSemDuplicados,
                                            complete: _.get(result, "complete", false)
                                        });
                                    });
                                }}/>
                            {this.props.controller.verificarCargoPresente(this.props.matriculaEmpregadosSubstituidos[i])}
                            <div
                                className={this.props.solicitacaoExcecao ? "multiple-selects-buttons no-buttons" : "multiple-selects-buttons"}>
                                {(this.props.controller.quantidadeEmpregadosSubstituidosMostrados > empregadosSubstituidosMin && this.props.controller.quantidadeEmpregadosSubstituidosMostrados > 1) &&
                                    <a onClick={() => this.props.removerEmpregadoSubstituido(i, this.props.empregadosSubstituidosMin)}
                                       title="Remover"><FontAwesome name="minus-circle"/></a>
                                }
                                {(this.props.controller.quantidadeEmpregadosSubstituidosMostrados < empregadosSubstituidosMax) &&
                                <a onClick={() => this.props.adicionarEmpregadoSubstituido(i, this.props.empregadosSubstituidosMax)}
                                   title="Adicionar"><FontAwesome name="plus-circle"/></a>
                                }
                            </div>
                        </div>
                        </FormGroup>
                    }
                    </Col>
                </Row>)
        }


        return (
            <div>
                <h4>Empregado substituído</h4>
                {empregadosSubstituidosForm}
                <FormGroup>
                    <Validacao id="empregadosUnicos" valor={this.props.controller.apenasMatriculaEmpregadosSubstituidosValidos}
                               tipo={["isArrayUnique","empregadosSubstituidosMin",empregadosSubstituidosMin,"empregadosSubstituidosMax",empregadosSubstituidosMax]}/>
                    <Validacao id="empregadosMesmoCargo" valor={this.props.controller.empregadosFiltradosSelecionados}
                               tipo={["empregadosMesmoCargo"]}/>
                </FormGroup>
            </div>
        )
    }
}